/** @format */

// NOTE: Do not use `backticks` in config files, as it breaks Internet Explorer.

const API_DOMAIN = 'api.galabid.com';
const CMS_API_URL = 'https://' + API_DOMAIN + '/api/cms/';
const APP_API_URL = 'https://' + API_DOMAIN + '/api/app/';
const BASE_API_URL = 'https://' + API_DOMAIN + '/';

const CONFIG = {
    __: 'production',
    API_DOMAIN: API_DOMAIN,
    CMS_API_URL: CMS_API_URL,
    APP_API_URL: APP_API_URL,
    BASE_API_URL: BASE_API_URL,
    STATIC_ASSETS: 'https://s3-ap-southeast-1.amazonaws.com/presenter.galabid.com/static/',
};

module.exports = CONFIG;
